﻿export default class MultipleTooltipFormControl {
    constructor(item, multipleTooltipRow, opts) {
        this.item = item;
        this.multipleTooltipRow = multipleTooltipRow;
        this.opts = opts;
        this.formId = 'multipleTooltipForm';
        this.formContentId = 'multipleTooltipFormContent';
        this.treeId = 'ctrlTooltipRuleTree';
        this.filterId = 'tooltipRuleItemsFilter';
        this.addButtonId = 'addTooltipButton';
        this.deleteTooltipItemClass = 'deleteTooltipItem';
        this.selectionTooltipLabelId = 'selTooltipLabel';
        this.tooltipContentId = 'divTooltipEdit';
        this.tooltipTitleId = 'currentTooltipTitle';
        this.tooltipTableFieldId = 'currentTooltipTableField';
        this.tooltipInterpretationId = 'currentTooltipInterpretationId';
        this.tooltipFormatId = 'currentTooltipFormatId';
        this.tooltipWidthId = 'currentTooltipWidthId';
        this.tooltipHiddenId = 'currentTooltipHiddenId';
        this.cancelTooltipId = 'currentCancelTooltipId';
        this.saveTooltipId = 'currentSaveTooltipId';
        this.tooltipLabelWrapper = 'tooltipLabelWrapper';
        this.tooltipTableFieldWrapper = 'tooltipTableFieldWrapper';
        this.window = null;
        this.tree = null;
        this.fieldCombo = null;
        this.interpretationCombo = null;
        this.tooltipRules = null;
        this.tooltipDataSource = null;
        this.currentTooltip = null;
        this.currentNodeDataTooltip = null;
    }

    show() {
        if ($('#' + this.formId).length == 0) {
            $("body").append('<div id="' + this.formId + '"></div>');
        }

        this.window = $('#' + this.formId).kendoWindow({
            title: this.opts.localization.Add,
            visible: false,
            modal: true,
            resizable: false,
            actions: [
                "Close"
            ],
            open: () => {
                this._initContent();
            },
            close: () => {
                this._destroy();
            }
        });
        this.window = $('#' + this.formId).data('kendoWindow');
        this.window.open();
        this.window.center();
    }

    _initContent() {
        $('#' + this.formId).append('<div class="panel-container show"><div class="panel-content p-0"><div class="panel-content"><div id="' + this.formContentId + '" class="panel-content d-flex flex-grow-1 p-0 pb-3 "></div></div></div></div>');
        $('#' + this.formId).append(this._createButtons());
        $('#' + this.formId).append(this._getTreeKendoTemplate());
        $('#' + this.formContentId).append(this._getTooltipTreeTemplate());
        $('#' + this.formContentId).append(this._getTooltipContentTemplate());

        this.tooltipRules = this.item[this.multipleTooltipRow] != null && this.item[this.multipleTooltipRow] != '' ? JSON.parse(this.item[this.multipleTooltipRow]) : [];

        this.tooltipDataSource = new kendo.data.HierarchicalDataSource({
            data: this.tooltipRules, schema: {
                model: {
                    id: "idx",
                    children: "children"
                }
            }
        });

        $("#" + this.treeId).kendoTreeView({
            loadOnDemand: false,
            dataSource: this.tooltipDataSource,
            dragAndDrop: false,
            dataTextField: "title",
            select: (node) => {
                this._select(node.node);
            },
            change: () => { },
            collapse: () => { },
            expand: () => { },
            template: kendo.template($("#rule-tooltip-item-template").html()),
            dragstart: () => { },
            drop: () => { }
        });
        this.tree = $("#" + this.treeId).data('kendoTreeView');
        this._addEvents();
    }

    _select(node) {
        if (this.currentTooltip != null) {
            this._saveCurrentTooltip();
        }

        this.currentTooltip = null;
        $('#' + this.tooltipLabelWrapper).show();
        $('#' + this.tooltipContentId)[0].innerHTML = '';
        this.currentNodeDataTooltip = this.tree.dataItem(node);
        this.currentTooltip = this._cloneNodeData(this.currentNodeDataTooltip);

        $('#' + this.selectionTooltipLabelId).text(this.currentTooltip.title);

        $('#' + this.tooltipContentId).append(this._createTitleInput());
        $('#' + this.tooltipTitleId).val(this.currentTooltip.title != 'New Item' ? this.currentTooltip .title : '');

        $('#' + this.tooltipContentId).append(this._createTableFieldInput());
        $('#' + this.tooltipContentId).append(this._createInterpretationInput());
        $('#' + this.tooltipContentId).append(this._createFormatInput());
        $('#' + this.tooltipFormatId).val(this.currentTooltip.format);
        $('#' + this.tooltipContentId).append(this._createWidthInput());
        $('#' + this.tooltipWidthId).val(this.currentTooltip.width);
        $('#' + this.tooltipContentId).append(this._createHiddenInput());
        $('#' + this.tooltipHiddenId)[0].checked = this.currentTooltip.canBeHidden;

        $('#' + this.tooltipTitleId).on('keyup', () => {
            $('#' + this.selectionTooltipLabelId).text($('#' + this.tooltipTitleId).val());
            this.currentTooltip.title = $('#' + this.tooltipTitleId).val();
            this._saveCurrentTooltip();
        });

        $('#' + this.tooltipFormatId).on('keyup', () => {
            this.currentTooltip.format = $('#' + this.tooltipFormatId).val();
        });

        $('#' + this.tooltipWidthId).on('keyup', () => {
            this.currentTooltip.width = $('#' + this.tooltipWidthId).val();
        });

        $('#' + this.tooltipHiddenId).on('change', () => {
            this.currentTooltip.canBeHidden = $('#' + this.tooltipHiddenId)[0].checked;
        });

        var fieldDatasource = new kendo.data.DataSource({
            transport: {
                read: {
                    url: this.opts.fieldUrl,
                    dataType: "json"
                }
            }
        });

        $('#' + this.tooltipTableFieldId).kendoComboBox({
            dataSource: fieldDatasource,
            select: (e) => {
                this.currentTooltip.field = e.item.text();
                this._saveCurrentTooltip();
            },
            dataBound: () => {
                if (this.currentTooltip.field != null && this.currentTooltip.field != '') {
                    this.fieldCombo.select(this._getCurrentFieldIndex());
                }
            }
        });

        this.fieldCombo = $('#' + this.tooltipTableFieldId).data('kendoComboBox');

        if (this.currentTooltip.field == null || this.currentTooltip.field == '') {
            $('#' + this.tooltipTableFieldWrapper).kendoValidator().data("kendoValidator").validate();
        }
        
        $('#' + this.tooltipInterpretationId).kendoComboBox({
            dataSource: this._getInterpretations(),
            select: (e) => {
                this.currentTooltip.interpretation = e.item.text();
            }
        });

        this.interpretationCombo = $('#' + this.tooltipInterpretationId).data('kendoComboBox');

        if (this.currentTooltip.interpretation != null && this.currentTooltip.interpretation != '') {
            this.interpretationCombo.text(this.currentTooltip.interpretation);
            this.interpretationCombo.value(this.currentTooltip.interpretation);
        }
    }

    _getCurrentFieldIndex() {
        var idx = -1;

        for (var i = 0; i < this.fieldCombo.dataSource._data.length; i++) {
            if (this.fieldCombo.dataSource._data[i] == this.currentTooltip.field) {
                idx = i;
            }
        }

        return idx;
    }

    _cloneNodeData(node) {
        var dataItem = {
            idx: node.idx,
            title: node.title,
            field: node.field,
            format: node.format,
            interpretation: node.interpretation,
            width: node.width,
            canBeHidden: node.canBeHidden,
            children: null
        };

        return dataItem;
    }

    _saveCurrentTooltip() {
        var currentIdx = -1;

        for (var i = 0; i < this.tooltipRules.length; i++) {
            if (this.tooltipRules[i].idx == this.currentTooltip.idx) {
                currentIdx = i;
                break;
            }
        }

        this.tooltipRules[currentIdx] = this.currentTooltip;
        this.currentNodeDataTooltip.title = this.currentTooltip.title;
        this.currentNodeDataTooltip.interpretation = this.currentTooltip.interpretation;
        this.currentNodeDataTooltip.format = this.currentTooltip.format;
        this.currentNodeDataTooltip.field = this.currentTooltip.field;
        this.currentNodeDataTooltip.width = this.currentTooltip.width;
        this.currentNodeDataTooltip.canBeHidden = this.currentTooltip.canBeHidden;
        this.currentNodeDataTooltip.children = this.currentTooltip.children;

        this.tree.dataSource.filter({});
        this._addTooltipRemoveEvent();
    }

    _storeTooltip() {
        this.item.MultipleTooltip = this.tooltipRules == 0 ? null : JSON.stringify(this.tooltipRules);

        if (this.item.MultipleTooltip != null) {
            $('#multipleTooltipButton')[0].innerText = this.opts.localization.Edit;
        } else {
            $('#multipleTooltipButton')[0].innerText = this.opts.localization.Add;
        }

        $('#multipleTooltipDetails')[0].innerText = this.getTooltipDescription();
    }

    getTooltipDescription() {
        if (this.tooltipRules.length == 0) {
            return '';
        }

        var result = '(';
        for (var i = 0; i < this.tooltipRules.length; i++) {
            result += this.tooltipRules[i].title != null && this.tooltipRules[i].title != '' && this.tooltipRules[i].title != 'New Item' ? this.tooltipRules[i].title : this.tooltipRules[i].field;

            if (i != this.tooltipRules.length - 1) {
                result += ', ';
            }
        }

        result += ')';
        return result;
    }

    _cancelCurrentTooltip() {
        this._destroy();
    }

    _createTitleInput() {
        var content = '<div class="form-row mb-2">';
        content += '<div class="col-xl-3" style="line-height: 2rem;">';
        content += '<label for="' + this.tooltipTitleId + '" class="form-label pr-2">' + this.opts.localization.MultipleTooltipTitle + '</label>';
        content += '</div>';
        content += '<div class="col-xl-9">';
        content += '<div class="form-group">';
        content += '<input id="' + this.tooltipTitleId + '" name="' + this.tooltipTitleId + '" type="text" class="form-control form-control-sm">';
        content += '</div>';
        content += '</div>';
        content += '</div>';
        return content;
    }

    _createTableFieldInput() {
        var content = '<div class="form-row mb-2" id="' + this.tooltipTableFieldWrapper + '">';
        content += '<div class="col-xl-3" style="line-height: 2rem;">';
        content += '<label for="' + this.tooltipTableFieldId + '" class="form-label pr-2">' + this.opts.localization.MultipleTooltipField + '</label>';
        content += '</div>';
        content += '<div class="col-xl-9">';
        content += '<div class="form-group">';
        content += '<input id="' + this.tooltipTableFieldId + '" name="' + this.tooltipTableFieldId + '" type="text" class="form-control form-control-sm" data-val="true" data-val-required="' + this.opts.localization.MultipleTooltipFieldValidation + '">';
        content += '<span class="k-invalid-msg" data-for="' + this.tooltipTableFieldId + '" data-valmsg-for="' + this.tooltipTableFieldId + '"></span>';
        content += '</div>';
        content += '</div>';
        content += '</div>';
        return content;
    }

    _createInterpretationInput() {
        var content = '<div class="form-row mb-2">';
        content += '<div class="col-xl-3" style="line-height: 2rem;">';
        content += '<label for="' + this.tooltipInterpretationId + '" class="form-label pr-2">' + this.opts.localization.MultipleTooltipInterpretation + '</label>';
        content += '</div>';
        content += '<div class="col-xl-9">';
        content += '<div class="form-group">';
        content += '<input id="' + this.tooltipInterpretationId + '" name="' + this.tooltipInterpretationId + '" type="text" class="form-control form-control-sm">';
        content += '</div>';
        content += '</div>';
        content += '</div>';
        return content;
    }

    _createFormatInput() {
        var content = '<div class="form-row mb-2">';
        content += '<div class="col-xl-3" style="line-height: 2rem;">';
        content += '<label for="' + this.tooltipFormatId + '" class="form-label pr-2">' + this.opts.localization.MultipleTooltipFormat + '</label>';
        content += '</div>';
        content += '<div class="col-xl-9">';
        content += '<div class="form-group">';
        content += '<input id="' + this.tooltipFormatId + '" name="' + this.tooltipFormatId + '" type="text" class="form-control form-control-sm">';
        content += '</div>';
        content += '</div>';
        content += '</div>';
        return content;
    }

    _createWidthInput() {
        var content = '<div class="form-row mb-2">';
        content += '<div class="col-xl-3" style="line-height: 2rem;">';
        content += '<label for="' + this.tooltipWidthId + '" class="form-label pr-2">' + this.opts.localization.MultipleTooltipWidth + '</label>';
        content += '</div>';
        content += '<div class="col-xl-9">';
        content += '<div class="form-group">';
        content += '<input id="' + this.tooltipWidthId + '" name="' + this.tooltipWidthId + '" type="text" class="form-control form-control-sm">';
        content += '</div>';
        content += '</div>';
        content += '</div>';
        return content;
    }

    _createHiddenInput() {
        var content = '<div class="form-row mb-2">';
        content += '<div class="col-xl-3" style="line-height: 2rem;">';
        content += '<label for="' + this.tooltipHiddenId + '" class="form-label pr-2">' + this.opts.localization.MultipleTooltipHidden + '</label>';
        content += '</div>';
        content += '<div class="col-xl-9" style="line-height: 2rem;">';
        content += '<div class="form-group">';
        content += '<input class="k-checkbox k-valid" id="' + this.tooltipHiddenId + '" name="' + this.tooltipHiddenId + '" style="width:100%;" type="checkbox" value="false">';
        content += '<label class="k-checkbox-label" for="' + this.tooltipHiddenId + '"></label>';
        content += '<input name="' + this.tooltipHiddenId + '" style="width:100%;" type="hidden" value="false" class="k-valid">';
        content += '</div>';
        content += '</div>';
        content += '</div>';
        return content;
    }

    _createButtons() {
        var content = '<div class="panel-content border-faded border-left-0 border-right-0 border-bottom-0 d-flex flex-row align-items-right pt-3">';
        content += '<button class="btn btn-secondary ml-auto" id="' + this.cancelTooltipId + '" title="' + this.opts.localization.CancelChanges + '" type="button">' + this.opts.localization.Cancel + '</button>';
        content += '<button class="btn btn-primary ml-2" id="' + this.saveTooltipId + '" title="Ok" type="button">' + this.opts.localization.Ok + '</button>';
        content += '</div>'
        return content;
    }

    _addEvents() {
        $('#' + this.filterId).on('keyup', () => {
            this._filterTooltipRuleTree();
        });

        $('#' + this.addButtonId).on('click', () => {
            this._addTooltipNode();
        });

        $('#' + this.cancelTooltipId).on('click', () => {
            this._cancelCurrentTooltip();
        });

        $('#' + this.saveTooltipId).on('click', () => {
            this._saveCurrentTooltip();
            this._storeTooltip();
            this._destroy();
        });

        this._addTooltipRemoveEvent();
    }

    _addTooltipRemoveEvent() {
        $('.' + this.deleteTooltipItemClass).on('click', (evt) => {
            var idx = $(evt.currentTarget).attr('data-ref');
            this._removeTooltipNode(idx);
        });
    }

    _filterTooltipRuleTree() {
        var filterValue = $('#' + this.filterId).val();
        if (this.tree == null) {
            return;
        }
        this.tree.select(null);
        if (filterValue) {
            this.tree.dataSource.filter({
                field: "title",
                operator: "contains",
                value: filterValue
            });
        }
        else {
            this.tree.dataSource.filter({});
        }
        this._addTooltipRemoveEvent();
    }

    _removeTooltipNode(idx) {
        var dataItem = this.tree.dataSource.get(idx);
        var element = this.tree.findByUid(dataItem.uid);

        this.tree.remove(element);
        this.tree.dataSource.filter({});
        this._addTooltipRemoveEvent();

        var listIdx = -1;
        for (var i = 0; i < this.tooltipRules.length; i++) {
            if (this.tooltipRules[i].idx == idx) {
                listIdx = i;
                break;
            }
        }

        if (listIdx >= 0);
        this.tooltipRules.splice(listIdx, 1);
    }

    _addTooltipNode() {
        $('#' + this.filterId).val('')
        this.tree.dataSource.filter({});
        var lastIdx = this.tooltipRules.length > 0 ? this.tooltipRules[this.tooltipRules.length - 1].idx : 0;
        var newItem = {
            idx: lastIdx + 1,
            children: null,
            title: 'New Item'
        }
        this.tooltipRules.push(newItem);
        var newNode = this.tree.append(newItem);
        this.tree.dataSource.filter({});
        this._addTooltipRemoveEvent();
        if (newNode != null) {
            this.tree.select(newNode);
            this._select(newNode);
        }
    }

    _getTooltipContentTemplate() {
        var content = '<div id="js-tooltip-rules-definition" class="d-flex flex-column flex-grow-1 bg-transparent pane-content" style="width:30rem;">';
        content += '<div id="divTooltipContent" class="panel-content mt-0 pt-2 pl-5 pr-4" style="width:100%;">';
        content += '<div class="form-row" id="' + this.tooltipLabelWrapper + '" style="display: none;">';
        content += '<div class="col-xl-12 d-flex align-items-center pb-2 border-bottom mb-3 ">';
        content += '<a href="javascript:void(0);" class=" p-0 py-2 d-flex d-lg-none align-items-center justify-content-center mr-2 btn waves-effect waves-themed" data-action="toggle" data-class="slide-on-mobile-left-show" data-target="#pnlTooltipRulesList">';
        content += '<i class="fal fa-ellipsis-v h1 mb-0 "></i>';
        content += '</a>';
        content += '<h1 class="subheader-title ml-1 ml-lg-0" id="' + this.selectionTooltipLabelId + '">';
        content += '</h1>';
        content += '</div>';
        content += '</div>';
        content += '<div class="form-row">';
        content += '<div class="col-xl-12">';
        content += '<div class="panel-content">';
        content += '<div id="' + this.tooltipContentId + '">';
        content += '</div>';
        content += '</div>';
        content += '</div>';
        content += '</div>';
        content += '</div>';
        content += '</div>';

        return content;
    }

    _getTooltipTreeTemplate() {
        var content = '<div id="pnlTooltipRulesList" class="flex-wrap position-relative bg-white slide-on-mobile slide-on-mobile-left border-right pane-content pr-2" style="width:25rem;">';
        content += '<div class="form-row mb-2">';
        content += '<div class="col-xl-12 d-flex justify-content-between">';
        content += '<div class="input-group menu-items-filter-ctrl" style="max-width:17.5rem;">';
        content += '<input type="text" id="' + this.filterId + '" class="form-control shadow-inset-2" placeholder="' + this.opts.localization.Search + '" style="max-width:17.5rem;">';
        content += '<div class="input-group-append">';
        content += '<span class="input-group-text"><i class="fal fa-search"></i></span>';
        content += '</div>';
        content += '</div>';
        content += '<div class="d-flex justify-content-end">';
        content += '<button type="button" id="' + this.addButtonId + '" class="btn btn-sm btn-outline-primary waves-effect waves-themed mr-1"><span class="ni ni-plus mr-1"></span>' + this.opts.localization.Add + '</button>';
        content += '</div>';
        content += '</div>';
        content += '</div>';
        content += '<div class="form-row">';
        content += '<div class="col-xl-12">';
        content += '<div id="ctrlTooltipRuleTree" style="min-height:30rem; border:none !important;"></div>';
        content += '</div>';
        content += '</div>';
        content += '</div>';
        content += '<div class="slide-backdrop" data-action="toggle" data-class="slide-on-mobile-left-show" data-target="#pnlTooltipRulesList"></div>';

        return content;
    }

    _getTreeKendoTemplate() {
        var content = '<script id="rule-tooltip-item-template" type="text/kendo-ui-template">';
        content += '<div class="rule-style-item">';
        content += '#if(item.field == null || item.field.length == 0){#<span style="color: red"><span class="k-icon k-i-warning" />#}#<span class="mr-4">#: item.title #</span>#if(item.field == null || item.field.length == 0){#</span>#}#';
        content += '<a class="btn btn-icon btn-sm ' + this.deleteTooltipItemClass + '" data-ref="#: item.idx #" title="' + this.opts.localization.Delete + '">';
        content += '<i class="fal fa-trash-alt"/>';
        content += '</a>';
        content += '</div>';
        content += '</script>';

        return content;
    }

    _destroy() {
        this.item = null;
        this.multipleTooltipRow = null;
        this.title = null;
        this.tooltipRules = null;
        this.tooltipDataSource = null;
        this.tree = null;
        this.fieldCombo = null;
        this.interpretationCombo = null;
        this.currentTooltip = null;
        this.currentNodeDataTooltip = null;
        this.window.destroy();
        $('#' + this.formId).remove();
    }

    _getInterpretations() {
        return ['String', 'Boolean', 'Date', 'Number', 'Url'];
    }
}